import { TechDocPage, TechDocWizardPage } from '../containers/pages';
import { PRODUCT_ID_OAAS, ALLETRAMP_VIDEO_URL } from '../constants';
//import { powerupInit } from './alletraMPPagesConfigCommon';
import { gettingStarted } from './oaasPagesConfigComm';

const softwareConfigPath = '/software-config/';
const physicalInstallPath = '/physical-install/';
const fieldInstallPath = `${physicalInstallPath}install/`;
const fieldCablePath = `${physicalInstallPath}cable/`;
const fieldUnboxPath = `${physicalInstallPath}unbox/`;

export const pagesConfig = [
  ...gettingStarted(PRODUCT_ID_OAAS),
  {
    path: physicalInstallPath,
    menuText: 'physicalInstallation',
    exact: true,
    redirectTo: fieldUnboxPath,
    submenuItems: [
      {
        path: fieldUnboxPath,
        menuText: 'unbox',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRAMP_VIDEO_URL.UNBOX_ALLETRAMPX10000,
        },
      },
      {
        path: fieldInstallPath,
        menuText: 'rack',
        exact: true,
        redirectTo: `${fieldInstallPath}1`,
      },
      {
        path: `${fieldInstallPath}:step`,
        exact: true,
        component: TechDocWizardPage,
        pageName: 'rackSwitched',
        pageProps: {
          steps: [
            {
              steptitle: 'Plan Rack Layout',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.RACK_ALLETRAMPX10000_STEP1,
              steptitle: 'Install Switch Rail Shelves and Cable Tray',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.RACK_ALLETRAMPX10000_STEP2,
              steptitle: 'Install Switches',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.RACK_ALLETRAMPX10000_STEP3,
              steptitle: 'Install Chassis Rail Shelves',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.RACK_ALLETRAMPX10000_STEP4,
              steptitle: 'Install Chassis',
            },
          ],
        },
      },
      {
        path: fieldCablePath,
        menuText: 'cable',
        exact: true,
        redirectTo: `${fieldCablePath}1`,
      },
      {
        path: `${fieldCablePath}:step`,
        exact: true,
        component: TechDocWizardPage,
        pageName: 'cable',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRAMP_VIDEO_URL.CABLE_ALLETRAMPX10000_STEP1,
              steptitle: 'Cable Admin Ports',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.CABLE_ALLETRAMPX10000_STEP2,
              steptitle: 'Cable Data Ports',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.CABLE_ALLETRAMPX10000_STEP3,
              steptitle: 'Cable Hosts',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.CABLE_ALLETRAMPX10000_STEP4,
              steptitle: 'Cable Power Supplies',
            },
          ],
        },
      },
      {
        path: `${physicalInstallPath}powerOn`,
        menuText: 'powerOn',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRAMP_VIDEO_URL.POWERON_ALLETRAMPX10000,
        },
      },
    ],
  },
  {
    path: `${softwareConfigPath}`,
    menuText: 'softwareConfig',
    exact: true,
    redirectTo: `${softwareConfigPath}discoverCluster`,
    submenuItems: [
      {
        path: `${softwareConfigPath}discoverCluster`,
        menuText: 'discoverCluster',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: '',
        },
      },
      {
        path: `${softwareConfigPath}connectCluster`,
        menuText: 'connectCluster',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRAMP_VIDEO_URL.CONNECT_ALLETRAMPX10000_WIZARDDISCOVERYTOOL,
        },
      },
      {
        path: `${softwareConfigPath}setupCluster`,
        menuText: 'setupCluster',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRAMP_VIDEO_URL.SETUP_ALLETRAMPX10000,
        },
      },
      {
        path: `${softwareConfigPath}completeSetup`,
        menuText: 'setupComplete',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
    ],
  },
];
